export default __webpack_public_path__ + "static/media/Flower2.fc1fabe1.svg";